import { supabase } from './supabase';

// Obtener empresa del usuario actual
export const getEmpresa = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  const { data } = await supabase.from('usuarios').select('empresa_id, empresas(*)').eq('id', user.id).single();
  return data;
};

// Viajes
export const getViajes = async (empresaId) => {
  const { data, error } = await supabase.from('viajes').select('*, hitos(*), gastos(*)').eq('empresa_id', empresaId).order('created_at', { ascending: false });
  return { data, error };
};

export const crearViaje = async (viaje) => {
  const { data, error } = await supabase.from('viajes').insert(viaje).select().single();
  return { data, error };
};

export const actualizarViaje = async (id, cambios) => {
  console.log('Actualizando viaje:', id, cambios);
  const { data, error } = await supabase.from('viajes').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarViaje = async (id) => {
  const { error } = await supabase.from('viajes').delete().eq('id', id);
  return { error };
};

// Hitos
export const crearHito = async (hito) => {
  const { pendienteAprobacion, viaje, hitoConfig, ...hitoLimpio } = hito;
  const { data, error } = await supabase.from('hitos').insert(hitoLimpio).select().single();
  return { data, error };
};

export const actualizarHito = async (id, cambios) => {
  const { data, error } = await supabase.from('hitos').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarHito = async (id) => {
  const { error } = await supabase.from('hitos').delete().eq('id', id);
  return { error };
};

// Gastos
export const crearGasto = async (gasto) => {
  const { data, error } = await supabase.from('gastos').insert(gasto).select().single();
  return { data, error };
};

export const eliminarGasto = async (id) => {
  const { error } = await supabase.from('gastos').delete().eq('id', id);
  return { error };
};

// Alertas
export const getAlertas = async (empresaId) => {
  const { data, error } = await supabase.from('alertas').select('*').eq('empresa_id', empresaId).order('created_at', { ascending: false });
  return { data, error };
};

export const eliminarAlertaDB = async (id) => {
  const { error } = await supabase.from('alertas').delete().eq('id', id);
  return { error };
};

export const actualizarAlerta = async (id, cambios) => {
  const { data, error } = await supabase.from('alertas').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const crearAlerta = async (alerta) => {
  const { data, error } = await supabase.from('alertas').insert(alerta).select().single();
  return { data, error };
};


// Hitos config
export const getHitosConfig = async (empresaId) => {
  const { data, error } = await supabase.from('hitos_config').select('*').eq('empresa_id', empresaId).order('orden');
  return { data, error };
};

export const crearHitoConfig = async (hito) => {
  const { data, error } = await supabase.from('hitos_config').insert(hito).select().single();
  return { data, error };
};

export const actualizarHitoConfig = async (id, cambios) => {
  const { data, error } = await supabase.from('hitos_config').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarHitoConfig = async (id) => {
  const { error } = await supabase.from('hitos_config').delete().eq('id', id);
  return { error };
};

// Carriers
export const getCarriers = async (empresaId) => {
  const { data, error } = await supabase.from('carriers').select('*').eq('empresa_id', empresaId).order('nombre');
  return { data, error };
};

export const crearCarrier = async (carrier) => {
  const { data, error } = await supabase.from('carriers').insert(carrier).select().single();
  return { data, error };
};

export const actualizarCarrier = async (id, cambios) => {
  const { data, error } = await supabase.from('carriers').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarCarrier = async (id) => {
  const { error } = await supabase.from('carriers').delete().eq('id', id);
  return { error };
};

// Clientes
export const getClientes = async (empresaId) => {
  const { data, error } = await supabase.from('clientes').select('*').eq('empresa_id', empresaId).order('nombre');
  return { data, error };
};

export const crearCliente = async (cliente) => {
  const { data, error } = await supabase.from('clientes').insert(cliente).select().single();
  return { data, error };
};

export const actualizarCliente = async (id, cambios) => {
  const { data, error } = await supabase.from('clientes').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarCliente = async (id) => {
  const { error } = await supabase.from('clientes').delete().eq('id', id);
  return { error };
};

// Empresa
export const getEmpresaById = async (empresaId) => {
  const { data, error } = await supabase.from('empresas').select('*').eq('id', empresaId).single();
  return { data, error };
};

export const actualizarEmpresa = async (id, cambios) => {
  const { data, error } = await supabase.from('empresas').update(cambios).eq('id', id).select().single();
  return { data, error };
};

// Usuarios
export const getUsuarios = async (empresaId) => {
  const { data, error } = await supabase.from('usuarios').select('*').eq('empresa_id', empresaId).order('nombre');
  return { data, error };
};

// Plantillas
export const getPlantillas = async (empresaId) => {
  const { data, error } = await supabase.from('plantillas').select('*').eq('empresa_id', empresaId).order('created_at');
  return { data, error };
};

export const crearPlantilla = async (plantilla) => {
  const { data, error } = await supabase.from('plantillas').insert(plantilla).select().single();
  return { data, error };
};

export const actualizarPlantilla = async (id, cambios) => {
  const { data, error } = await supabase.from('plantillas').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarPlantilla = async (id) => {
  const { error } = await supabase.from('plantillas').delete().eq('id', id);
  return { error };
};
// Rutas
export const getRutas = async (empresaId) => {
  const { data, error } = await supabase.from('rutas').select('*').eq('empresa_id', empresaId).order('created_at', { ascending: false });
  return { data, error };
};

export const crearRuta = async (ruta) => {
  const { data, error } = await supabase.from('rutas').insert(ruta).select().single();
  return { data, error };
};

export const eliminarRuta = async (id) => {
  const { error } = await supabase.from('rutas').delete().eq('id', id);
  return { error };
};
// Contactos CRM
export const getContactos = async (empresaId) => {
  const { data, error } = await supabase.from('contactos').select('*').eq('empresa_id', empresaId).order('created_at', { ascending: false });
  return { data, error };
};

export const crearContacto = async (contacto) => {
  const { data, error } = await supabase.from('contactos').insert(contacto).select().single();
  return { data, error };
};

export const actualizarContacto = async (id, cambios) => {
  const { data, error } = await supabase.from('contactos').update(cambios).eq('id', id).select().single();
  return { data, error };
};

export const eliminarContacto = async (id) => {
  const { error } = await supabase.from('contactos').delete().eq('id', id);
  return { error };
};
// Normalizar texto para búsqueda sin acentos ni diéresis
export const normalizar = (str) => {
  if (!str) return '';
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
};

export const getLogoBase64 = async (logoUrl) => {
  try {
    const response = await fetch(logoUrl + '?t=' + Date.now());
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch { return null; }
};

export const subirLogo = async (empresaId, archivo) => {
  const ext = archivo.name.split('.').pop();
  const path = `${empresaId}/logo.${ext}`;
  const { error } = await supabase.storage.from('logos').upload(path, archivo, { upsert: true });
  if (error) return { error };
  const { data } = supabase.storage.from('logos').getPublicUrl(path);
  return { url: data.publicUrl };
};
